import Vue from 'vue'

// Lib imports
import axios from 'axios'

Vue.prototype.$http = axios;

// Load up the data from the env
const fallbackApiUrl = "http://localhost:8090";

const apiURL = process.env.VUE_APP_API_URL || fallbackApiUrl;

// Set the base URL to be the one from the env
Vue.prototype.$http.defaults.baseURL = apiURL;

// Assign the url as a global var. Use with this.API_URL or API_URL
Vue.prototype.API_URL = Vue.prototype.$http.defaults.baseURL;

// Static assets
Vue.prototype.STATIC_ASSETS_URL = process.env.VUE_APP_STATIC_ASSETS_URL || `${apiURL}/static/images`

console.log(`ENV = ${process.env.NODE_ENV}; API URL: ${Vue.prototype.$http.defaults.baseURL}`);

export default {
    apiUrl: apiURL,
}